import React, {Component} from 'react';
import {connect} from 'react-redux';
import {DocumentTitle, Page, Form, Icon, ValidatingInput, FancyButton} from '../widgets';
import Spinner from '../widgets/Spinner';
import {push} from 'connected-react-router';
import FancyLink from '../widgets/FancyLink';
import './GettingStarted.css';

const getSessionProvider = props => props && props.currentSession && props.currentSession.provider;
const getUniqueName = props => {
	const provider = getSessionProvider(props);
	return provider && provider.profile && provider.profile.uniqueName;
};

export const PresentationalGettingStartedBuilding = ({profileState, uniqueName}) => (
	<DocumentTitle title="B2Me">
		<Page className="GettingStarted scroll-anchor">
			{profileState === 'done' ? (
				<section className="GettingStarted-building">
					<p>
						<Icon name="done" size={480} />
					</p>
					<h1>Well done!</h1>
					<p style={{textAlign: 'center'}}>Your profile is now ready for viewing</p>
					<p>
						<FancyLink to={'/@' + encodeURIComponent(uniqueName)}>Take me there!</FancyLink>
					</p>
				</section>
			) : (
				<section className="GettingStarted-building">
					<Spinner />
					<p style={{textAlign: 'center'}}>Building profile...</p>
				</section>
			)}
		</Page>
	</DocumentTitle>
);

class GettingStartedBuilding extends Component {
	constructor(props) {
		super(props);
		this.state = {profileState: 'building'};
	}

	componentDidMount() {
		this.timeout1 = setTimeout(() => {
			this.setState({profileState: 'done'});
			this.timeout2 = setTimeout(() => {
				this.props.next(getUniqueName(this.props));
			}, 5000);
		}, 2000);
	}

	componentWillUnmount() {
		if (this.timeout1 != null) clearTimeout(this.timeout1);
		if (this.timeout2 != null) clearTimeout(this.timeout2);
	}

	render() {
		return (
			<PresentationalGettingStartedBuilding
				profileState={this.state.profileState}
				uniqueName={getUniqueName(this.props)}
			/>
		);
	}
}

const ConnectedGettingStartedBuilding = connect(
	({session}) => ({
		currentSession: session && session.current
	}),
	dispatch => ({
		next: uniqueName => dispatch(push('/@' + encodeURIComponent(uniqueName)))
	})
)(GettingStartedBuilding);

export default ConnectedGettingStartedBuilding;



// WEBPACK FOOTER //
// ./src/profile/GettingStartedBuilding.js